const buildInvoiceNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) => {
  const query = new URLSearchParams(listContext.locationSearch || "");
  query.set("status", status || query.get("status") || "all");
  return `/invoice/${recordId}/${activeSubPage}?${query.toString()}`;
};

export { buildInvoiceNavigationTargetUrl };
